export enum StreamStatus {
    /**
     * 开始处理，但未获取到数据
     * @description 是客户端标记状态
     */
    PROGRESS_WITHOUT_DATA = 'PROGRESS_WITHOUT_DATA',
    /**
     * 处理中
     * @description 是服务端发送的状态
     */
    PROCESSING = 'PROCESSING',
    /**
     * 完成
     * @description 是服务端发送的状态
     */
    FINISH = 'FINISH',
    /**
     * 中止
     * @description 是客户端标记的状态
     */
    ABORTED = 'ABORTED'
}

/**
 * SSE 首次响应超时时间
 */
export const SSE_FIRST_RESPONSE_TIMEOUT = 3000000;

/**
 * SSE 进度超时时间
 */
export const SSE_PROGRESS_TIMEOUT = 3000000;

/**
 * SSE 错误消息 - 首次响应超时
 */
export const SSE_ERROR_MESSAGE_FIRST_RESPONSE_TIMEOUT = 'Timeout: No response received within 30 seconds of connection';

/**
 * SSE 错误消息 - 进度超时
 */
export const SSE_ERROR_MESSAGE_PROGRESS_TIMEOUT = 'Timeout: No progress received within 30 seconds of connection';
